import React, { useState } from 'react';

import { Modal } from '../../../../components';

import { GreenShoppingCart } from '../../../../assets/svg-image/modal';

import SquadBoldText from '../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import SquadSemiBoldText from '../../../../components/Text/SquadSemiBoldText';
import RowCenter from '../../../../components/Layout/RowCenter';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import { closeBlack } from '../../../../assets/Base64Image';
import Button from '../../../../components/Button';
import RowBetween from '../../../../components/Layout/RowBetween';
import ColumnCenter from '../../../../components/Layout/ColumnCenter';
import Column from '../../../../components/Layout/Column';
import Row from '../../../../components/Layout/Row';
import QuestionIcon from './QuestionIcon';
import DividerLine from '../../../../components/DividerLine';
import Input from '../../../../components/Input';
import SquadExtraBoldText from '../../../../components/Text/SquadExtraBoldText';
import PhoneNumberText from '../../../../components/PhoneNumberText';

const OrderCheckoutModal: React.FC<Props> = ({
  onClose,
  onConfirm,
  isEnglish,
}) => {
  const [errorPromoCode, setErrorPromoCode] = useState<boolean>(false);

  return (
    <Modal
      style={{ width: 303, minWidth: 'unset', padding: 'unset', paddingBottom: 26, borderRadius: 42 }}
    >
      {/* 图标 */}
      <RowCenter>
        <img src={GreenShoppingCart} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </RowCenter>
      {/* 关闭图标 */}
      <Button
        onClick={() => onClose()}
        style={{ padding: 10, width: 30, height: 30, marginLeft: 'auto', marginRight: 10, marginTop: -10 }}
      >
        <img src={closeBlack} style={{ width: 14, height: 14 }} />
      </Button>

      <RowCenter>
        {
          isEnglish ? (
            <SquadBoldText fontSize={22} letterSpacing={1} marginTop={5}>
              Order checkout
            </SquadBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={22} letterSpacing={1} marginTop={5}>
              订单结算
            </PingFangSemiBoldText>
          )
        }
      </RowCenter>

      <RowCenter>
        <Column style={{ width: 271, marginTop: 20 }}>
          {
            isEnglish ? (
              <SquadSemiBoldText fontSize={16} lineHeight={25} letterSpacing={1}>
                Order details:
              </SquadSemiBoldText>
            ) : (
              <PingFangMediumText fontSize={16} lineHeight={27} letterSpacing={1}>
                订单详情：
              </PingFangMediumText>
            )
          }

          {
            isEnglish ? (
              <RowBetween>
                <SquadRegularText fontSize={16} lineHeight={25} letterSpacing={1}>
                  Total time:
                </SquadRegularText>
                <SquadRegularText fontSize={16} lineHeight={25} letterSpacing={1}>
                  3 Hours
                </SquadRegularText>
              </RowBetween>
            ) : (
              <RowBetween>
                <PingFangRegularText fontSize={16} lineHeight={27} letterSpacing={1}>
                  总时长：
                </PingFangRegularText>
                <PingFangRegularText fontSize={16} lineHeight={27} letterSpacing={1}>
                  3 小时
                </PingFangRegularText>
              </RowBetween>
            )
          }

          {
            isEnglish ? (
              <RowBetween>
                <SquadSemiBoldText fontSize={16} lineHeight={25} letterSpacing={1}>
                  Free time:
                </SquadSemiBoldText>
                <SquadSemiBoldText fontSize={16} lineHeight={25} letterSpacing={1}>
                  1 Hour
                </SquadSemiBoldText>
              </RowBetween>
            ) : (
              <RowBetween>
                <PingFangMediumText fontSize={16} lineHeight={27} letterSpacing={1}>
                  免费时长：
                </PingFangMediumText>
                <PingFangMediumText fontSize={16} lineHeight={27} letterSpacing={1}>
                  1 小时
                </PingFangMediumText>
              </RowBetween>
            )
          }

          {
            isEnglish ? (
              <RowBetween>
                <Row>
                  <SquadSemiBoldText fontSize={16} lineHeight={25} color={'#00B595'} letterSpacing={1}>
                    Paid time:
                  </SquadSemiBoldText>
                  <QuestionIcon isEnglish={isEnglish} marginLeft={3} />
                </Row>
                <SquadSemiBoldText fontSize={16} lineHeight={25} color={'#00B595'} letterSpacing={1}>
                  2 Hours
                </SquadSemiBoldText>
              </RowBetween>
            ) : (
              <RowBetween>
                <Row>
                  <PingFangMediumText fontSize={16} lineHeight={27} color={'#00B595'} letterSpacing={1}>
                    付费时长：
                  </PingFangMediumText>
                  <QuestionIcon isEnglish={isEnglish} />
                </Row>
                <PingFangMediumText fontSize={16} lineHeight={27} color={'#00B595'} letterSpacing={1}>
                  2 Hours
                </PingFangMediumText>
              </RowBetween>
            )
          }

          {
            isEnglish ? (
              <RowBetween style={{ marginTop: 5 }}>
                <SquadRegularText fontSize={16} lineHeight={25} letterSpacing={1}>
                  Subtotal:
                </SquadRegularText>
                <SquadRegularText fontSize={16} lineHeight={25} color={'#00B595'} letterSpacing={1}>
                  $2.00
                </SquadRegularText>
              </RowBetween>
            ) : (
              <RowBetween style={{ marginTop: 5 }}>
                <PingFangRegularText fontSize={16} lineHeight={27} letterSpacing={1}>
                  小计：
                </PingFangRegularText>
                <SquadRegularText fontSize={16} lineHeight={27} color={'#00B595'} letterSpacing={1}>
                  $2.00
                </SquadRegularText>
              </RowBetween>
            )
          }

          <DividerLine marginTop={25} backgroundColor={'#11202B'} opacity={0.1} />

          {
            isEnglish ? (
              <SquadSemiBoldText fontSize={16} lineHeight={25} marginTop={15} letterSpacing={1}>
                Promotional code:
              </SquadSemiBoldText>
            ) : (
              <PingFangMediumText fontSize={16} lineHeight={27} marginTop={15} letterSpacing={1}>
                促销代码：
              </PingFangMediumText>
            )
          }
          <Column>
            <Row style={{ border: '1px solid', borderColor: errorPromoCode ? '#F44336' : '#00B595', borderRadius: 20, height: 40, width: 271 }}>
              <Input
                width={'100%'}
                height={30}
                borderRadius={20}
                placeholderColor={errorPromoCode ? '#F44336' : '#00B595'}
                placeholderOpacity={0.2}
                letterSpacing={1}
                lineHeight={22}
                fontFamily={'Squad-SemiBold'}
                fontSize={16}
                color={errorPromoCode ? '#F44336' : '#00B595'}
                placeholder={isEnglish ? 'Promotional code' : '促销代码'}
                style={{ paddingLeft: 12 }}
              />
              <Button
                minWidth={73}
                maxWidth={73}
                height={40}
                marginLeft={0}
                marginRight={0}
                backgroundColor={errorPromoCode ? '#F44336' : '#00B595'}
                borderRadius={'0 19px 19px 0'}
              >
                {
                  isEnglish ? (
                    <SquadSemiBoldText fontSize={16} color={'#FFFFFF'}>
                      Apply
                    </SquadSemiBoldText>
                  ) : (
                    <PingFangMediumText fontSize={16} color={'#FFFFFF'}>
                      使用
                    </PingFangMediumText>
                  )
                }
              </Button>
            </Row>
            {
              errorPromoCode && (
                <>
                  {
                    isEnglish ? (
                      <SquadRegularText color={'#F44336'} lineHeight={25} marginLeft={13}>
                        *Invalid promo code
                      </SquadRegularText>
                    ) : (
                      <PingFangRegularText color={'#F44336'} lineHeight={27} marginLeft={13}>
                        *无效的促销代码
                      </PingFangRegularText>
                    )
                  }
                </>
              )
            }
          </Column>

          {
            isEnglish ? (
              <RowBetween style={{ marginTop: 10 }}>
                <SquadSemiBoldText fontSize={16} lineHeight={25} marginLeft={13} letterSpacing={1}>
                  Applied discount:
                </SquadSemiBoldText>
                <SquadSemiBoldText fontSize={16} lineHeight={25} marginRight={13} letterSpacing={1}>
                  $0.00
                </SquadSemiBoldText>
              </RowBetween>
            ) : (
              <RowBetween style={{ marginTop: 10 }}>
                <PingFangMediumText fontSize={16} lineHeight={27} marginLeft={13} letterSpacing={1}>
                  已用优惠：
                </PingFangMediumText>
                <SquadSemiBoldText fontSize={16} lineHeight={27} marginRight={13} letterSpacing={1}>
                  $0.00
                </SquadSemiBoldText>
              </RowBetween>
            )
          }

          <DividerLine marginTop={15} backgroundColor={'#11202B'} opacity={0.1} />

          {
            isEnglish ? (
              <RowBetween style={{ marginTop: 15 }}>
                <SquadExtraBoldText fontSize={16} lineHeight={25} color={'#00B595'} letterSpacing={1}>
                  Total:
                </SquadExtraBoldText>
                <SquadBoldText fontSize={16} lineHeight={25} color={'#00B595'} letterSpacing={1}>
                  $2.00
                </SquadBoldText>
              </RowBetween>
            ) : (
              <RowBetween style={{ marginTop: 15 }}>
                <PingFangSemiBoldText fontSize={16} lineHeight={27} color={'#00B595'} letterSpacing={1}>
                  总计：
                </PingFangSemiBoldText>
                <SquadBoldText fontSize={16} lineHeight={27} color={'#00B595'} letterSpacing={1}>
                  $2.00
                </SquadBoldText>
              </RowBetween>
            )
          }

          {
            isEnglish ? (
              <RowBetween>
                <SquadRegularText fontSize={16} lineHeight={25} color={'#00B595'} letterSpacing={1}>
                  Recipient’s number:
                </SquadRegularText>
                <SquadRegularText fontSize={16} lineHeight={25} color={'#00B595'} letterSpacing={1}>
                  <PhoneNumberText phoneNumber={'407745109'} />
                </SquadRegularText>
              </RowBetween>
            ) : (
              <RowBetween>
                <PingFangRegularText fontSize={16} lineHeight={27} color={'#00B595'} letterSpacing={1}>
                  收件人号码：
                </PingFangRegularText>
                <SquadRegularText fontSize={16} lineHeight={27} color={'#00B595'} letterSpacing={1}>
                  <PhoneNumberText phoneNumber={'407745109'} />
                </SquadRegularText>
              </RowBetween>
            )
          }
        </Column>
      </RowCenter>

      <RowCenter>
        <Button width={265} height={60} borderRadius={60} boxShadow={'0px 22px 30px 0px rgba(0,181,149,0.05)'} backgroundColor={'#00B595'} marginTop={15} onClick={() => onConfirm()}>
          {
            isEnglish ? (
              <ColumnCenter>
                <SquadBoldText fontSize={18} lineHeight={21} color={'#FFFFFF'} letterSpacing={1}>
                  Payment method
                </SquadBoldText>
                <SquadRegularText fontSize={18} lineHeight={21} color={'#FFFFFF'} letterSpacing={1}>
                  $2.00
                </SquadRegularText>
              </ColumnCenter>
            ) : (
              <ColumnCenter>
                <PingFangSemiBoldText fontSize={18} lineHeight={23} color={'#FFFFFF'} letterSpacing={1}>
                  支付方式
                </PingFangSemiBoldText>
                <SquadRegularText fontSize={18} lineHeight={21} color={'#FFFFFF'} letterSpacing={1}>
                  $2.00
                </SquadRegularText>
              </ColumnCenter>
            )
          }
        </Button>
      </RowCenter>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  onConfirm: () => void;
  isEnglish: boolean;
}

export default OrderCheckoutModal;
